import { Component, output, input, linkedSignal, ChangeDetectionStrategy, model } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'search',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComponent extends InputComponent {
    readonly items = model<any[]>([]);

    complete = output<any>();

    filtered: Observable<any[]> = of([]);

    onPick($event: MatAutocompleteSelectedEvent): void {
        this.complete.emit($event.option.value);
    }

    protected filterItems(value: string): any[] {
        const filterValue = value.toLowerCase();
        const result = this.items().filter(item => item.name.toLowerCase().includes(filterValue));
        const meta = this.meta();
        return result && result.length > 0 ? result : meta && meta.forge ? meta.forge(value) : result;
    }
}
